module.exports = __webpack_public_path__ + "img/zlindex7.26847c8c.png";